import { TextField } from 'src/components/TextField';

interface AffiliateCodeFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const AffiliateCodeFilter: React.FC<AffiliateCodeFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  if (valueOnly) {
    return <>{value || ''}</>;
  }

  return (
    <TextField
      label={label}
      value={value || ''}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Enter Code"
    />
  );
};
